import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type { ComponentType } from "react";

export interface TableActionProps<Row> {
  label: string;
  disabled?: boolean;
  row: Row;
  Icon?: ComponentType<SvgIconProps>;
  handleClose?: () => void;
  actionCallback: (row: Row) => void;
}

const TableAction = <Row,>({
  label,
  row,
  Icon,
  disabled = false,
  handleClose,
  actionCallback,
}: TableActionProps<Row>) => {
  const handleOptionClicked = () => {
    actionCallback(row);
    if (handleClose) handleClose();
  };
  return (
    <MenuItem onClick={handleOptionClicked} disabled={disabled}>
      {Icon && (
        <ListItemIcon>
          <Icon fontSize="small" />
        </ListItemIcon>
      )}
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};

export { TableAction };
